export const emailRegexp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const charsAndDigitsRegexp = /^[a-zA-Z0-9]*$/;
export const numericRegexp = /^[0-9]*$/;
export const ibanRegexp = /^[a-zA-Z0-9]{28,28}$/;
export const currentAccountRegexp = /^[a-zA-Z0-9]{20,20}$/;
export const bankNameRegexp = /^[A-Za-zА-Яа-я0-9ёË/\-,." ]*$/;
